import BaseState from '@state/BaseState'
import GameStatesEnum from "../GameStatesEnum";
import { Signals} from "@/Imports";


export default class OutroFreespinsState extends BaseState {
  begin() {
    this.model.isFreespinsStarted = false;
    this.model.isFreespinsMode = false
    Signals.outroFreespins.dispatch(this.model.freespins)
    Signals.outroFreespinsComplete.addOnce(this.end, this)
  }

  end = () => {
    this.gameState = GameStatesEnum.IDLE; //GameStatesEnum.BONUS_WIN_ADD
    this.model.currentsymbolsMultipliers = {}
    this.stateMachine.setState(this.gameState)
  }

  cleanUp() {
    Signals.outroFreespinsComplete.remove(this.end, this)
  }
}